import type { CampaignStatus, SendMode } from './types';

export interface MarketingCampaignRow {
  id: string;
  name: string;
  status: CampaignStatus;
  audienceName: string;
  eligible?: number;
  scheduledAt: string | null;
  createdAt: string | null;
  sendMode: SendMode | null;
  sent?: number;
}

export interface MarketingCampaignFilters {
  query: string;
  status: 'all' | CampaignStatus;
  sendMode: 'all' | SendMode;
  from: string;
  to: string;
}

export const EMPTY_CAMPAIGN_FILTERS: MarketingCampaignFilters = {
  query: '',
  status: 'all',
  sendMode: 'all',
  from: '',
  to: '',
};

function dayStamp(value: string): number | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const parsed = new Date(trimmed.includes('T') ? trimmed : `${trimmed}T12:00:00`);
  const time = parsed.getTime();
  return Number.isNaN(time) ? null : time;
}

function rowStamp(row: MarketingCampaignRow): number | null {
  return dayStamp(row.scheduledAt || row.createdAt || '');
}

export function filterCampaignRows(rows: MarketingCampaignRow[], filters: MarketingCampaignFilters): MarketingCampaignRow[] {
  const term = filters.query.trim().toLowerCase();
  const from = filters.from ? dayStamp(filters.from) : null;
  const to = filters.to ? dayStamp(filters.to) : null;
  const toEnd = to == null ? null : to + 24 * 60 * 60 * 1000 - 1;

  return rows.filter((row) => {
    if (filters.status !== 'all' && row.status !== filters.status) return false;
    if (filters.sendMode !== 'all' && row.sendMode !== filters.sendMode) return false;
    if (term && !row.name.toLowerCase().includes(term) && !row.audienceName.toLowerCase().includes(term)) return false;
    if (from != null || toEnd != null) {
      const stamp = rowStamp(row);
      if (stamp == null) return false;
      if (from != null && stamp < from) return false;
      if (toEnd != null && stamp > toEnd) return false;
    }
    return true;
  });
}
